(function($) {
jQuery(document).ready(function(){
    jQuery(document).on('click','#infiniteoptions-container .card-message-option .card_button_option',function(){
    var contentes = jQuery(this).data('content');
      jQuery('.card-message-content textarea').html((contentes?contentes:''));
    });
  
  setInterval(function(){
    if(jQuery('#infiniteoptions-container').html()){
      if(!jQuery('#infiniteoptions-container div').hasClass('append-card-message')){
      jQuery('<div class="card-message-option append-card-message">'+jQuery('.card-message-option').html()+'</div>').insertAfter('#infiniteoptions-container .card-message-content');
    
      }
    }
  });
  
  setTimeout(function() {
        var maxLength = 200;
        jQuery("<span class='reached-mesage' style='display:none; color:#ff0000;'>Text limit reached</span>").insertBefore("#infiniteoptions-container .append-card-message");
        jQuery('.card-message-content textarea').on('input', function(e) {
            var inputText = jQuery(this).val();
            var inputTextWithoutSpaces = inputText.replace(/\s+/g, '');
            var charCount = inputTextWithoutSpaces.length;
    
            if (charCount > maxLength) {
                jQuery('.reached-mesage').show(); 
                jQuery(this).val(inputText.substring(0, jQuery(this).data('lastValidValue').length));
            } else {
                jQuery('.reached-mesage').hide();
                jQuery(this).data('lastValidValue', inputText);
            }
    
            //jQuery('#charCount').text('Characters without spaces: ' + charCount);
        });
        jQuery('.card-message-content textarea').data('lastValidValue', '');
    }, 4000);
    
  });
})(jQuery);
  
  
